import { Query } from "../utils/types";
import { get } from "./";

export function search(params: Partial<Query>) {
  return get("Affinity/Platform/Search", params);
}
